import m from 'mithril';
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Button from 'flarum/common/components/Button';

// 默认首页偏好：forum=论坛 / portal=阅览室
// 登录用户存 preference（跨设备），游客存 cookie（仿核心 locale 切换器模式）
const PREF_KEY = 'portalHome';
const COOKIE_NAME = 'flarumPortalHome';
const PORTAL_PATH = '/portal';
const COOKIE_MAX_AGE = 31536000; // 一年

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}
function getCurrentPreference() {
  if (app.session?.user) {
    const prefs = app.session.user.preferences() || {};
    return prefs[PREF_KEY] || 'forum';
  }
  return getCookie(COOKIE_NAME) || 'forum';
}
function savePreference(value) {
  if (app.session?.user) {
    return app.session.user.savePreferences({
      [PREF_KEY]: value
    });
  }
  document.cookie = COOKIE_NAME + '=' + encodeURIComponent(value) + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
  return Promise.resolve();
}

// 后台「论坛首页」是否已选「阅览室」（服务端下发 portalHomeEnabled）。
// 开启后根路径 '/' 的渲染由服务端 PortalRootMiddleware 按偏好接管，
// 前端不再自行 replace /portal，切换目标也统一回根路径（地址保持 /）。
// 注意：不能依赖 defaultRoute==='/portal' 判断——偏好 forum 的用户收到的
// defaultRoute 已被服务端改写为 '/'，会误判未开启。
function isPortalHomeEnabled() {
  return app.forum.attribute('portalHomeEnabled') === true;
}

// 访问站点根路径 '/' 时按偏好跳转；爬虫无 cookie、游客无偏好 → 保持论坛首页，零 SEO 影响
function applyHomeRedirect() {
  const path = window.location.pathname;
  if (path !== '/' && path !== '') return;
  // 已开启「Home Page=阅览室」：根路径由服务端渲染（阅览室或论坛），前端不二次跳转
  if (isPortalHomeEnabled()) return;
  if (getCurrentPreference() === 'portal') {
    window.location.replace(app.forum.attribute('baseUrl') + PORTAL_PATH);
  }
}
function switchHome() {
  const current = getCurrentPreference();
  const next = current === 'portal' ? 'forum' : 'portal';
  savePreference(next).then(() => {
    // 开启「Home Page=阅览室」时切到阅览室直接回根路径（服务端渲染，地址保持 /）
    window.location.href = next === 'portal' ? isPortalHomeEnabled() ? '/' : PORTAL_PATH : '/';
  });
}
app.initializers.add('flarum-portal-forum', () => {
  // 核心 boot 时序：initialize()（扩展 initializer）先于 app.session 创建执行，
  // 因此首页跳转检查必须注册到 beforeMount（session 就绪后、页面渲染前）。
  app.beforeMount(applyHomeRedirect);

  // 登录用户：头像下拉菜单加「默认首页」切换项（存 preference）
  extend(SessionDropdown.prototype, 'items', function (items) {
    const current = getCurrentPreference();
    const isPortal = current === 'portal';
    items.add('portalHome', m(Button, {
      icon: isPortal ? 'fas fa-book-open' : 'fas fa-home',
      onclick: switchHome
    }, isPortal ? '默认首页：阅览室（点击切回论坛）' : '默认首页：论坛（点击切到阅览室）'), -95);
  });

  // 游客：没有头像下拉，在头部右侧加一个同款切换按钮（存 cookie）
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (app.session.user) return;
    const current = getCurrentPreference();
    const isPortal = current === 'portal';
    items.add('portalHome', m(Button, {
      className: 'Button Button--link',
      icon: isPortal ? 'fas fa-book-open' : 'fas fa-home',
      onclick: switchHome
    }, isPortal ? '阅览室首页' : '论坛首页'), 25);
  });
});